'use client';

import { Icon } from '@/components/icons/svg-icons';
import { menuIconStyle } from '../sidebar/components/sidebar-item/sidebar-item.style';
import { useTranslations } from 'next-intl';
import { useSportMenuItemGetter } from '@/hooks/query';
import { useRouter } from 'next/navigation';
import { isVirtualSports } from '@/services/settings.service';

export const ThirdPartyTopMenu = ({ sportId } : {sportId : number}) => {
	const t = useTranslations('General');
	const { getSportMenuItemsOfMode } = useSportMenuItemGetter();
	const menuData = getSportMenuItemsOfMode('M0');
	const router = useRouter();
	const backToSports = () => {
		const defaultSportHref = menuData.at(0)?.href ?? '';
		router.push(defaultSportHref);
	}
	const isVirtualSport = isVirtualSports(sportId);
	return (
		<div className="page-top-bar">
			<div className="page-top-bar__title">{t(`lbl_${sportId}`)}</div>
			<button className="btn btn--goto-sports" onClick={backToSports}>
				<div className="btn__text">{t('lbl_SportsParty')}</div>
				<Icon name="arrow-right" className={menuIconStyle.rightIcon} />
			</button>
		</div>
	);
};
